import { getClient } from "./client-helper";
import { Document } from "./dtos";

export const emailDocuments = async (emailTos: string [], message: string, documents: Document[]) => {
  const {gatewayApiUri, authToken} = await getClient();
  const bookingNumber = documents[0].bookingNumber;

  const response = await fetch(`${gatewayApiUri}/Notifications/Documents`, {
    headers: {
      "Authorization": `Bearer ${authToken}`,
      "Content-Type": "application/json"
    },
    method: 'Post',
    body: JSON.stringify({
      "bookingId": bookingNumber,
      "emailAddresses": emailTos,
      "message": message,
      "documents": documents,
      "language": "en-US"
    }),
  });

  if (!response.ok) {
    return Promise.reject(response.statusText);
  }
}

export const emailShareTracking = async (emailTos: string [], message: string, trackingNumber:string) => {
  const {gatewayApiUri, authToken} = await getClient();

  const response = await fetch(`${gatewayApiUri}/Notifications/Tracking`, {
    headers: {
      "Authorization": `Bearer ${authToken}`,
      "Content-Type": "application/json"
    },
    method: 'Post',
    body: JSON.stringify({
      "emailAddresses": emailTos,
      "message": message,
      "trackingNumber": trackingNumber,
    }),
  });

  if (!response.ok) {
    return Promise.reject(response.statusText);
  }
}

